<template>
<div>
    <div class="mcc-page-header" >
        <div class="mu-d-flex mu-flex-column mu-w-100 mu-gap-04">
            <div class="mu-d-flex mu-justify-content-between mu-align-items-center mu-flex-wrap">
                <section class="mu-d-flex mu-flex-row mu-w-100">
                    <h1 class="mu-mb-00">System template details</h1>
                    <details class="mcc-popover mcc-popover--bottom-end">
                        <summary class="mcc-button mcc-button--icon-only ">
                            <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                        </summary>
                        <div class="mcc-popover__content">
 
                            <p class="mu-mb-00">
                                {{ helpText.title }}
                                <a :href="helpText.url" target="_blank">Read more...</a>
                            </p>
                        </div>
                    </details>
                   
                </section>
            </div>
        </div>
    </div>
    <div class="mcc-container-fluid card-padding">
        <div>
            <nav aria-label="breadcrumb" class="">
                <ol class="mcc-breadcrumb">
                    <li>Administration</li>
                    <li>
                        System templates
                    </li>
                    <li class="lastBredCrumpLi"></li>
                </ol>
            </nav>
        </div>
        
        <div class="relativePosition">
            <div v-if="!fetchCall" class="spinner-overlay zIndex10">
                <div class="spinner-background"></div>
                <div class="spinner-flex spinner-text">
                    <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                        <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                        <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                    </svg>
                </div>
            </div>
            <form novalidate @submit.prevent="saveEmailTemplate()">
                <div class="mcc-row">
                    <div class="mcc-col mcc-col-md-12">
                        <div class="mcc-card">
                            <div class="mcc-card__header">
                                <h2 class="mcc-card__title  ">Templates</h2>
                            </div>
                            <div class="mcc-card__body">
                                <div class="mcc-row">
                                    <div class="mcc-col">
                                        <div class="mfc-slim-select-wrapper mu-mb-03">
                                            <select @change="loadSystemTemplates($event)" ref="dropdownRef" name="template-select" id="template-selectId" class="mfc-slim-select">
                                                <option value="newTask" :selected="true">New task</option>
                                                <option value="reassignedTask">Reassigned task</option>
                                                <option value="delegateTask">Delegate task</option>
                                                <option value="involveUser"> Involve user</option>
                                                <option value="newComment">New comment</option>
                                                <option value="importSuccessHeader">Import success header</option>
                                                <option value="importFailureHeader">Import failure header</option>
                                                <option value="importFooter">Import footer</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="mcc-row">
                                    <div class="mcc-col">
                                        <div class="mfc-textarea-wrapper summernote mfc-form-input-container" ref="templateData" >
                                            <textarea id="templateData" name="templateData"></textarea>
                                        </div>
                                        <div class="mt-1"> <small class="text-muted" v-if="selectedTemplate != 'importSuccessHeader' && selectedTemplate != 'importFailureHeader' && selectedTemplate != 'importFooter'" :value="templatedData" @change="templatedData = event.target.value">
                                                Add variables Assignee/Reason/Process/Task with '${' and '@' to select user e.g. ${Process}.
                                            </small></div>
                                        <div> <small class="text-muted">
                                                {{supportedVarsHelpText == '' ? 'Available variables for New task: Assignee, Task' : supportedVarsHelpText}}
                                            </small></div>
                                    </div>
                                </div>
                                <div class="mu-d-flex mu-justify-content-end d-flex justify-content-end" spaced="">
                                    <div role="group" class="mcc-button-group mcc-button-group--spaced">
                                        <button class="mcc-button mcc-button--success" title="Save" id="saveBtn" type="submit">
                                            <mcc-icon name="save" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Save</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
</template>

<style scoped>

</style>

<script>
import TemplateAPI from "../../../services/TemplateAPI";
import {
    EventBus
} from "../../../services/event-bus";
import constantMessages from "../../../messages";
import MyTaskListAPI from "../../../services/MyTaskListAPI";
import Utils from "@/script_utils";

export default {
    name: "SystemTemplates",
    data() {
        return {
            helpText: constantMessages.BREADCRUMB_HELP["admin.systemtemplates"],
            showHelpText: false,
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            selectedTemplate: "newTask",
            templatedData: "",
            fetchCall: false,
            variablesArray: [],
            userList: [],
            supportedVarsHelpText: '',
        }
    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);

        let self = this;
        self.fetchCall = false;
        self.variablesArray = ["Assignee", "Reason", "Process", "Task"];
        MyTaskListAPI.getUsers().then(result => {
            self.userList = result.map(a => a.username);
            self.initializeSummernote();
            self.getSystemTemplates(self.selectedTemplate);
        });
        new SlimSelect({
            select: '#template-selectId'
        })
    },
    methods: {
        loadSystemTemplates(e) {
            let self = this;
            switch (e.target.value) {
                case "newTask":
                    self.supportedVarsHelpText = "Available variables for New task: Assignee, Task";
                    break;
                case "reassignedTask":
                    self.supportedVarsHelpText = "Available variables for Reassigned task: Assignee, Reason, Process, Task";
                    break;
                case "delegateTask":
                    self.supportedVarsHelpText = "Available variables for Delegate task: Assignee, Reason, Process, Task";
                    break;
                case "involveUser":
                    self.supportedVarsHelpText = "Available variables for Involve user: Assignee, Reason, Process, Task";
                    break;
                case "newComment":
                    self.supportedVarsHelpText = "Available variables for New comment: Process, Task";
                    break;
                case "importSuccessHeader":
                    self.supportedVarsHelpText = "No variables available for Import success header";
                    break;
                case "importFailureHeader":
                    self.supportedVarsHelpText = "No variables available for Import failure header";
                    break;
                case "importFooter":
                    self.supportedVarsHelpText = "No variables available for Import footer";
                    break;
            }
            self.selectedTemplate = e.target.value
            self.fetchCall = false;
            self.getSystemTemplates(self.selectedTemplate);
        },
        getSystemTemplates(templateName) {
            let self = this;

            TemplateAPI.getSystemTemplates(templateName).then(response => {
                self.fetchCall = true;
                self.templatedData = response;
                $(".summernote").summernote('code', "");
                if (response.templateData != null && response.templateData != "") {

                    $(".summernote").summernote('code', response.templateData);

                }
            });
        },
        initializeSummernote() {
            let self = this;
            $('.summernote')
                .summernote({
                    height: 400,
                    callbacks: {
                        onInit: function () {
                            Utils.bindSummerNoteHintPatch();
                        },
                        onKeyup: function (e) {
                            e.stopPropagation();
                        },
                        onKeydown: function (e) {
                            if (e.keyCode == 27) {
                                return;
                            }
                            e.stopPropagation();
                        }
                    },
                    toolbar: [
                        ['style', ['style']],
                        [
                            'font',
                            ['bold', 'italic',
                                'underline',
                                'clear'
                            ]
                        ],
                        ['fontname', ['fontname']],
                        ['fontsize', ['fontsize']],
                        ['color', ['color']],
                        [
                            'para',
                            ['ul', 'ol',
                                'paragraph'
                            ]
                        ],
                        ['height', ['height']]

                    ],
                    fontSizes: ['8', '10', '12', '14',
                        '16', '18', '24', '36', '48'
                    ],
                    hint: [{
                        mentions: self.userList,
                        match: /\B@(\w*)$/,
                        search: function (keyword, callback) {
                            callback($.grep(this.mentions, function (item) {
                                return item.indexOf(keyword) == 0;
                            }));
                        },
                        content: function (item) {
                            return '@' + item;
                        }
                    }, {
                        match: /\B[$][{](\w*)$/,
                        search: function (keyword, callback) {
                            callback($.grep(self.variablesArray, function (item) {
                                return item.indexOf(keyword) === 0;
                            }));
                        },
                        content: function (item) {
                            return '${' + item + '}';
                        }
                    }]
                });
        },
        saveEmailTemplate() {
            let self = this;
            let data = $(".summernote").summernote('code');
            self.templatedData.templateData = $('.summernote').summernote('isEmpty') ? "" : data;
            self.templatedData.taskName = self.selectedTemplate;
            self.fetchCall = false;
            TemplateAPI.saveSystemTemplates(
                    self.templatedData
                )
                .then(response => {
                    self.fetchCall = true;
                    if (response != undefined) {
                        if (response.error) {
                            EventBus.$emit("error-notification", {
                                msg: constantMessages.MESSAGES[response.message]
                            });
                        } else {

                            EventBus.$emit("success-notification", {
                                msg: constantMessages.MESSAGES[response.message]
                            });
                        }
                    }
                })
                .finally(() => {});
        }

    }
}
</script>
